import { render } from "./TabApi.vue?vue&type=template&id=395c2326&scoped=true"
import script from "./TabApi.vue?vue&type=script&lang=js"
export * from "./TabApi.vue?vue&type=script&lang=js"

import "./TabApi.vue?vue&type=style&index=0&id=395c2326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395c2326"]])

export default __exports__